import moment from 'moment'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { Button } from '@driftt/dds'
import { ToolTip } from '@driftt/tide-core'

import './style.css'

const ErrorButtonCell = ({
  numberErrors,
  jobId,
  userListName 
}) => {
  const history = useHistory()
  if (!numberErrors || numberErrors === 0) {
    return null
  }
  
  return (
    <Button
      variant="secondary"
      onClick={() => history.push(`/imports/logs/marketo/${jobId}?title=${userListName}`)}
    >
      View logs
    </Button>
  )
}

export const Columns = [
  {
    label: 'List name',
    value: 'userListName',
    sortable: false,
    width: '300px',
    className: 'marketo-import-logs--table-header--sticky'
  },
  {
    label: 'List type',
    value: 'listType',
    sortable: false,
    className: 'marketo-import-logs--table-header--sticky'
  },
  {
    label: 'Import created',
    value: 'createdAt',
    sortable: false,
    className: 'marketo-import-logs--table-header--sticky'
  },
  {
    label: <ToolTip component={'Contacts added to this segment made from this Marketo list'} flow="down">Added to segment</ToolTip>,
    value: 'numberAdded',
    sortable: false,
    className: 'marketo-import-logs--table-header--sticky'
  },
  {
    label: <ToolTip component={'Contacts removed from the segment made from this Marketo list'} flow="down">Removed from segment</ToolTip>,
    value: 'numberRemoved',
    sortable: false,
    className: 'marketo-import-logs--table-header--sticky'
  },
  {
    label: <ToolTip component={'Drift only imports contacts with Munchkin cookies'} flow="down">Contacts not imported</ToolTip>,
    value: 'numberErrors',
    sortable: false,
    className: 'marketo-import-logs--table-header--sticky'
  }, 
  {
    label: '',
    value: '',
    sortable: false,
    width: '100px',
    className: 'marketo-import-logs--table-header--sticky'
  }
]

export const RowFormatter = (errorEntry) => {
  const listType = errorEntry.listType === 'SMART' ? 'Smart list ⚡️' : 'Static list'

  return {
    data: [
      { content: errorEntry.userListName },
      { content: listType },
      { content: moment(errorEntry.createdAt).format('MM/DD/YYYY') },
      { content: errorEntry.numberAdded },
      { content: errorEntry.numberRemoved },
      { content: errorEntry.numberErrors },
      { content: ErrorButtonCell(errorEntry) }
    ]
  }
}
